import { Controller } from "@hotwired/stimulus"

let debounce = undefined;

export default class extends Controller {
  static targets = [ 'input', 'hiddenInput', 'errorMessage', 'idsContainer']
  static values = {
    parserId: Number
  }

  ids = [];

  connect() {
    // console.log("Hello, Dak Tennis ID Helper Controller from Stimulus!", this.element)
    // console.log(this.inputTarget);
    // console.log(this.idsContainerTarget)
  }

  findDakTennisIds() {
    const files = this.inputTarget.files;
    // console.log('Files', files);

    const promises = Array.from(files).map(file => {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();

        reader.onload = (e) => {
          this.extractIds(reader.result);
          resolve();
        }

        reader.onerror = (e) => {
          reject(e);
        }

        reader.readAsText(file);
      });
    });

    Promise.all(promises).then(() => {
      // console.log('Extracted all of the IDs from the given files', this.ids);

      this.ids = Array.from(new Set(this.ids)); // remove duplicates

      this.displayIds();
    }).catch(error => {
      console.error('Error reading files', error);
    });
  }

  extractIds(csv) {
    const doc = new DOMParser().parseFromString(csv, 'text/xml');
    const found_ids = Array.from(doc.getElementsByTagName("Team")).map(team => team.getAttribute('abbr').trim());

    this.ids.push(...found_ids);
  }

  displayIds() {
    // console.log('ID Map', this.ids);

    this.ids.forEach(id => {
      const div = document.createElement('div');
      div.className = 'mb-4';

      // <%= check_box_tag 'ids[]', xml_id, false, { id: "entity_team_parser_ids_map_#{parser_id}_#{xml_id}", checked: false, class: 'me-3', data: { parser_id: parser_id, 'xml-help-target': 'foundXmlId', action: 'xml-help#constructParserIdsMap' } } %>
      // <%= label_tag 'ids[]', xml_id, for: "entity_team_parser_ids_map_#{parser_id}_#{xml_id}", class: 'me-5', data: { parser_id: parser_id, action: 'xml-help#constructParserIdsMap' } %>

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = 'ids[]';
      checkbox.value = id;
      checkbox.id = `entity_team_parser_ids_map_${this.parserIdValue}_${id}`;
      checkbox.checked = false;
      checkbox.className = 'me-3';
      div.appendChild(checkbox);

      const label = document.createElement('label');
      label.htmlFor = `entity_team_parser_ids_map_${this.parserIdValue}_${id}`;
      label.textContent = id;
      div.appendChild(label);

      this.idsContainerTarget.appendChild(div);
    });

    const submitButton = document.querySelector(`#submit-id-helper-${this.parserIdValue}-modal`);
    if (submitButton) {
      submitButton.disabled = false;
    }
  }

}

